export function createStore() {
  return {
    namespaced: true,

    state: {
      isOpen: false,
    },

    getters: {
      isOpen: s => s.isOpen,
    },

    mutations: {
      OPEN_MOBILE_MENU(state)  { state.isOpen = true },
      CLOSE_MOBILE_MENU(state) { state.isOpen = false },
      TOGGLE_MOBILE_MENU(state){ state.isOpen = !state.isOpen },
    },

    actions: {
      openMobileMenu({ commit })  { commit('OPEN_MOBILE_MENU') },
      closeMobileMenu({ commit }) { commit('CLOSE_MOBILE_MENU') },
      toggleMobileMenu({ commit }){ commit('TOGGLE_MOBILE_MENU') },
    },
  }
}
